let dict = {}

// 從巢狀物件中取得資料
function getNested(obj, path){
    return path.split('.').reduce((o, k) => (o?.[k]), obj)
}

// 將變數插入模板字串中
// 文字檔內模板字串寫法
// greeting: {
//     hello: 'Hello, {name}!',
// }
function interpolate(str, params = {}){
    return str.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? `{${k}}`)
}

// 初始化 i18n
// 傳入 window.currLang (顯示語言) tc || jp || en
export async function initI18n(langCode){
    let fileName = 'zh-TW'; // 預設為繁體中文
    switch(langCode){
        case 'jp':
            fileName = 'ja';
            break;
        case 'en':
            fileName = 'en-US';
            break;
    }

    const langText = await import(`./${fileName}.js`);

    // 資料庫欄位 / 前端衍生欄位
    const field = await import(`./field/${fileName}.js`);

    // 與業務邏輯相關的前端設定
    const config = await import(`../locale-config/${fileName}.js`);

    dict = {...langText.default, ...field.default};
    dict.config = config.default;

    // console.log(dict);
}

/*
1. 直接取值 --> 儀表板
    window.t('menu.dashboard');
2. 將變數插入模板字串 --> 哈囉，v_k
    window.t(
        'greeting.hello',
        { name: 'v_k' }
    )
*/
// export function t(key, params) {
//     const str = getNested(dict, key)
//     return typeof str === 'string' ? interpolate(str, params) : key
// }

// 確保如果傳入 t('menu') 時，返回的是物件
export function t(key, params) {
  const value = getNested(dict, key);
  if (typeof value === 'object' && value !== null) return value;  // 原封不動回傳
  if (typeof value === 'string') return interpolate(value, params);
  return key;
}
